import * as React from 'react';
import { DropdownBackground } from './DropdownBackground';

import './DropdownBox.scss';

interface SGDropdownBoxProps {
    children: any;
    showBox: string;
    color?: string;
}

const Caret = (props: any) => (
    <div
        className={`dropdown-box__caret dropdown-box__caret--${props.color}`}
    ></div>
);

export const DropdownBox = (props: SGDropdownBoxProps) => (
    <div className={`dropdown-box__container ${props.showBox}`}>
        <Caret color={props.color} />
        <DropdownBackground>{props.children}</DropdownBackground>
    </div>
);
